import { FaInstagram, FaTiktok, FaWhatsapp, FaEnvelope, FaYoutube, FaFacebook,  } from 'react-icons/fa';

export const nav = [
    {
      icon: <FaYoutube />,
      path: "https://www.youtube.com/@GayaWalker",
    },
    {
      icon: <FaFacebook />,
      path: "https://web.facebook.com/GayaWalkerSL/?_rdc=1&_rdr",
    },
    {
      icon: <FaInstagram />,
      path: "https://www.instagram.com/gaya_walker/",
    },
    {
      icon: <FaTiktok />,
      path: "https://www.tiktok.com/@gaya_walker?lang=en",
    },
    {
      icon: <FaEnvelope />,
      path: "gayankanchana55@gmail.com",
    },
    {
      icon: <FaWhatsapp />,
      path: "+94753518586",
    },
];



  export const location = [
    {
      id: 1,
      name: "Name: Gayan Kanchana",
      Villas: "Bank : Commercial Bank - Welimada",
      Apartments: "Account No: 8000651260",
      cover: "./images/location/c1.jpeg",
    },
    {
      id: 2,
      name: "Name: Gayan Kanchana",
      Villas: "Bank : Peoples Bank - Ambagasdowa",
      Apartments: "Account No: 156200280019206",
      cover: "./images/location/c2.jpeg",
    },
  
  ]


